<template>
  <div class="recruitPartners">
    <div class="layout">
      <navMenu></navMenu>
      <banner title="效果图设计师" desc="我们不一样"></banner>
      <div class="bgwhite">
        <div class="container main">
          <div class="recru-top flex">
            <img src="../../assets/images/recruitPartners/group@2x.png" alt>
            <p>平台优势</p>
            <p>Platform advantage</p>
          </div>
          <div class="recru-bottom flex-center">
            <div class="profiles">
              <div v-for="(item,index) in leftList" :key="index">
                <div class="flex flex-y">
                  <img :src="item.img" alt>
                  <div class="text">
                    <p>{{item.title}}</p>
                    <p>{{item.context}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="profiles">
              <div v-for="(item,index) in rightList" :key="index">
                <div class="flex flex-y">
                  <img :src="item.img" alt>
                  <div class="text">
                    <p>{{item.title}}</p>
                    <p>{{item.context}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="introduce">
        <div class="container bgwhite">
          <div>
            <img class="top-img" src="../../assets/images/recruitPartners/message@2x.png" alt>
          </div>
          <div>
            <p>来图小助，你将不再被老板压榨。</p>
            <p>若你在传统效果图公司，加班熬夜没尽头，没时间玩游戏，深圳没时间找或陪女朋友，提成太低， 那你就来图小助开启你效果图设计助理生涯的外挂之旅吧！</p>
          </div>
        </div>
        <div class="content">
          <div class="title">
            <p>任职要求</p>
          </div>
          <div class="workquire flex flex-between">
            <div class="itemcard flex flex-y" v-for="(item,index) in workQuire" :key="index">
              <img class="numImg" :src="item.img" alt>
              <div class="textBorder flex-center bgwhite">
                <p>{{item.text}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom></bottom>
    <qrcode></qrcode>
  </div>
</template>

<script>
import navMenu from "@/components/navMenu";
import banner from "@/components/banner";
import bottom from "@/components/footer";
import qrcode from "@/components/qrcode";
export default {
  components: {
    navMenu,
    banner,
    bottom,
    qrcode
  },
  data() {
    return {
      leftList: [
        {
          img: require("../../assets/images/recruitPartners/service@2x.png"),
          title: "上门服务",
          context: "工作自由，想工作开启接单，想休息关闭接单。"
        },
        {
          img: require("../../assets/images/recruitPartners/time@2x.png"),
          title: "小时计费",
          context: "平台采用小时计费的标准，让效果图人的时间不被无情浪费"
        },
        {
          img: require("../../assets/images/recruitPartners/overTime@2x.png"),
          title: "加班高回报",
          context:
            "晚上12开始做图的价格是平时的1.5倍！不再让你无偿 熬夜至凌晨！"
        },
        {
          img: require("../../assets/images/recruitPartners/income@2x.png"),
          title: "收入即时提现",
          context: "服务完成当天即可申请提现，隔天到账！"
        }
      ],
      rightList: [
        {
          img: require("../../assets/images/recruitPartners/towing@2x.png"),
          title: "不拖款",
          context: "设计师下单时即付款，避免拖欠！"
        },
        {
          img: require("../../assets/images/recruitPartners/modifying@2x.png"),
          title: "不改图",
          context: "平台为客户准备了专业的改图团队，让万恶的改图，从此远离你。"
        },
        {
          img: require("../../assets/images/recruitPartners/percentage@2x.png"),
          title: "高提成",
          context:
            "收入你70%，平台30%，平台为你解决改图，业务，即时提现等一系列问题"
        },
        {
          img: require("../../assets/images/recruitPartners/guarantee@2x.png"),
          title: "收入保障",
          context:
            "平台有足够多的业务来源！可保证月收入不低于6000~若有不足 6000，平台会给补足至6000！"
        }
      ],
      workQuire: [
        {
          text: "至少两年以上的效果图工作经验。",
          img: require("../../assets/images/recruitPartners/num1@2x.png")
        },
        {
          text: "友好的服务态度，形象整洁",
          img: require("../../assets/images/recruitPartners/num2@2x.png")
        },
        {
          text: "能独立熟练的完成建模、渲染、后期。",
          img: require("../../assets/images/recruitPartners/num3@2x.png")
        }
      ]
    };
  }
};
</script>

<style lang="scss">
.recruitPartners {
  .layout {
    margin-bottom: 24px;
    .container {
      .recru-top {
        flex-direction: column;
        align-items: center;
        padding-top: 90px;
        img {
          width: 38px;
          height: 39px;
        }
        p {
          font-size: 22px;
          font-weight: bold;
          color: #212240;
          line-height: 30px;
          letter-spacing: 5px;
          margin-top: 12px;
          &:last-child {
            font-size: 5px;
            font-weight: 500;
            color: #a0a0ad;
            line-height: 13px;
            letter-spacing: 0;
            margin: 0;
          }
        }
      }
      .recru-bottom {
        .profiles {
          padding: 0 102px 0 140px;
          border-right: 3px solid #f5f5f7;
          margin: 71px 0 117px 0;
          height: 480px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          &:last-child {
            border-right: 0;
          }
          img {
            width: 80px;
            height: 80px;
          }
          p {
            width: 300px;
            font-size: 14px;
            color: #212240;
            margin-left: 20px;
            &:last-child {
              font-size: 12px;
              color: #80818f;
              margin-top: 5px;
            }
          }
        }
      }
    }
    .introduce {
      display: flex;
      justify-content: center;
      height: 324px;
      .container {
        position: absolute;
        min-width: 1100px;
        width: 1100px;
        height: 180px;
        box-shadow: 0px 2px 17px 2px rgba(230, 236, 244, 1);
        border-radius: 12px;
        top: 1100px;
        > div:nth-child(2) {
          margin-top: 66px;
          text-align: center;
          p {
            font-size: 12px;
            color: #555661;
            font-weight: bold;
            &:last-child {
              margin: 0 auto;
              margin-top: 12px;
              width: 602px;
              font-size: 14px;
              color: #abacc7;
              line-height: 20px;
            }
          }
        }
        .top-img {
          width: 68px;
          height: 68px;
          position: absolute;
          top: -34px;
          left: 516px;
        }
      }
      .content {
        margin-top: 162px;
        width: 1100px;
        .title {
          font-size: 16px;
          text-align: center;
          font-weight: bold;
          color: #212240;
        }
        .workquire {
          margin-top: 30px;
          .textBorder {
            width: 300px;
            height: 50px;
            border-radius: 27px;
            p {
              font-size: 12px;
              color: #212240;
              font-weight: 500;
            }
          }
          img {
            width: 37px;
            height: 37px;
            left: 20px;
          }
        }
      }
    }
  }
}
</style>
